import * as S from '@effect/schema/Schema';
export var ErrorBlockConfig = S.struct({
  typename: S.literal('ErrorBlock'),
  id: S.string,
  hash: S.string
});